import { render, staticRenderFns } from "./LeaderboardPageManagement.vue?vue&type=template&id=c18389e2&scoped=true"
import script from "./LeaderboardPageManagement.vue?vue&type=script&lang=js"
export * from "./LeaderboardPageManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18389e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c18389e2')) {
      api.createRecord('c18389e2', component.options)
    } else {
      api.reload('c18389e2', component.options)
    }
    module.hot.accept("./LeaderboardPageManagement.vue?vue&type=template&id=c18389e2&scoped=true", function () {
      api.rerender('c18389e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/LeaderboardPageManagement.vue"
export default component.exports